import { useQuery } from 'react-query';
import axiosInstance from './axiosInstance';
import { useAuthContext } from '../contexts/AuthContext';

const useFetch = (endpoint, id, data, interval, baseUrl) => {
    const { checkToken } = useAuthContext();

    const fetchData = async () => {
        try {
            const tokenIsValid = await checkToken();
            if (!tokenIsValid) {
                console.error("Token validation failed for endpoint:", endpoint);
                throw new Error("Authentication failed - token is invalid or expired");
            }

            const response = await axiosInstance('GET', endpoint, data, 'application/json', baseUrl);
            return response.data;
        } catch (err) {
            console.error(`[useFetch] Error fetching ${endpoint}:`, err?.message || err);
            throw err;
        }
    };

    return useQuery([id], () => fetchData(), {
        refetchOnWindowFocus: false,
        refetchInterval: interval,
        refetchIntervalInBackground: true,
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        staleTime: 0,
        keepPreviousData: true,
    });
};

export default useFetch;